module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0722.8368ab0b.jpg";